import { Eye } from "tabler-icons-react";

export const MinorHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },
  {
    id: "lookupName",
    numeric: false,
    disablePadding: true,
    label: "Minor",
  },
  {
    id: "state",
    numeric: false,
    disablePadding: true,
    label: "Status",
  },
  {
    id: "createdDate",
    numeric: false,
    date: true,
    disablePadding: true,
    label: "Created Date",
  },
  {
    id: "actions",
    view: <Eye />,
    numeric: false,
    label: "Actions",
  },
];
